// Imports
import { loadStripe } from '@stripe/stripe-js/pure';
import { useMemo } from 'react';
import thirdPartyIdentifiers from '../../../../../../shareables/third-party-identifiers';
import isScreenshot from '../../../../../../shareables/utils/is-screenshot';


// A hook that handles loading a Stripe instance
const useStripeInstance = (stripeAccountID: string) => {
	// Verify publishable keys exist
	if (!thirdPartyIdentifiers.stripePublishableKeys) {
		throw new Error('Missing required Stripe publishable keys');
	}
	
	
	// Memoize Stripe
	const publishableKey =
		thirdPartyIdentifiers.stripePublishableKeys[process.env.REACT_APP__ENVIRONMENT === 'production' ? 'live' : 'test'];
	
	const stripe = useMemo(() => {
		if (isScreenshot()) {
			return Promise.resolve(null);
		}
		
		return loadStripe(publishableKey, {
			stripeAccount: stripeAccountID,
		});
	}, [stripeAccountID, publishableKey]);
	
	
	// Return Stripe promise
	return stripe;
};

export default useStripeInstance;
